<template>
  <div class="go-web">
    <div style="background: rgba(249, 249, 249, 1)">
      <div class="header" id="header">
        <div class="text-box">
          <p class="header-title">{{ $t("RedteaGo.title") }}</p>
          <p class="header-content">{{ $t("RedteaGo.des") }}</p>
          <!--          <a href="https://www.redteago.com" target="blank">-->
          <!--            <p class="header-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>-->
          <!--          </a>-->
        </div>
        <div class="img-box">
          <img :src="goImg" />
        </div>
      </div>
    </div>

    <div class="tech">
      <p class="tech-title">{{ $t("RedteaGo.Highlights.title") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.des") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.content1") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.content2") }}</p>
      <p class="content" style="margin-bottom: 1.2rem">
        - {{ $t("RedteaGo.Highlights.content3") }}
      </p>
      <Divider />
    </div>
    <div class="flex-box" id="iosEsim">
      <div class="text-box" style="width: 5.5rem; padding-top: 0.9rem">
        <p class="title">{{ $t("RedteaGo.phoneTitle") }}</p>
        <div class="line"></div>
        <p
          style="
            color: rgba(32, 49, 82, 1);
            font-family: 'Poppins-Light';
            font-size: 14px;
            text-align: left;
            margin-top: 0.2rem;
          "
        >
          {{ $t("RedteaGo.phonetxt1") }}
          <a
            href="https://apps.apple.com/app/redteago/id1492864476"
            target="_blank"
            style="color: rgba(211, 36, 23, 1); text-decoration: underline"
            >{{ $t("RedteaGo.phonetxt2") }}</a
          >
          {{ $t("RedteaGo.phonetxt3") }}
        </p>
        <!--        <a href="https://www.redteago.com" target="blank">-->
        <!--          <p class="more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>-->
        <!--        </a>-->
      </div>
      <div class="img-box" style="margin-right: 1.46rem">
        <img src="../assets/go-web/get_web.png" style="width: 2.56rem" />
      </div>
    </div>
    <div style="width: 11.8rem; margin: auto">
      <Divider />
    </div>

    <div class="flex-box" style="padding-top: 0.4rem" id="Pixel">
      <div class="img-box">
        <img src="../assets/go-web/界面展示2.png" style="width: 4.36rem" />
      </div>
      <div class="text-box" style="width: 5.5rem; padding-top: 0.9rem">
        <p class="title">{{ $t("RedteaGo.pTitle") }}</p>
        <div class="line"></div>
        <p class="content">{{ $t("RedteaGo.pDes") }}</p>
        <!--        <a href="https://www.redteago.com/home/pixelesim.html" target="blank">-->
        <!--          <p class="more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>-->
        <!--        </a>-->
      </div>
    </div>

    <div style="width: 11.8rem; margin: auto">
      <Divider />
    </div>

    <!--    <div class="flex-box" id="iPhone">-->
    <!--      <div class="text-box" style="width:5.5rem;padding-top:0.9rem;">-->
    <!--        <p class="title">{{$t('RedteaGo.iTitle')}}</p>-->
    <!--        <div class="line"></div>-->
    <!--        <p class="content">{{$t('RedteaGo.iDes')}}</p>-->
    <!--        <a href="https://esim.redteago.com" target="blank">-->
    <!--          <p class="more">{{$t('learnMore')}}&nbsp;&nbsp;></p>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div class="img-box" style="margin-right:1.46rem;">-->
    <!--        <img src="../assets/go-web/1界面展示.png" style="width:2.56rem;" />-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div style="width:11.8rem;margin:auto;">-->
    <!--      <Divider />-->
    <!--    </div>-->

    <!--    <div class="flex-box" style="padding:0.3rem 0 0.75rem 0;" id="SIMCard">-->
    <!--      <div class="img-box">-->
    <!--        <img src="../assets/go-web/实体卡.png" style="width:4.6rem;margin-right:0.8rem;" />-->
    <!--      </div>-->
    <!--      <div class="text-box" style="width:5.5rem;margin-top:0.7rem;">-->
    <!--        <p class="title">{{$t('RedteaGo.sTitle')}}</p>-->
    <!--        <div class="line"></div>-->
    <!--        <p class="content">{{$t('RedteaGo.sDes')}}</p>-->
    <!--        <p-->
    <!--          style="color: rgba(32, 49, 82, 1);font-family: 'Poppins-Light';font-size: 14px;text-align: left;margin-top:0.2rem;"-->
    <!--        >-->
    <!--          {{$t('RedteaGo.sDes0')}}-->
    <!--          <a-->
    <!--            href="mailto:communications@redteamobile.com"-->
    <!--            style="color:rgba(211, 36, 23, 1);text-decoration:underline"-->
    <!--          >communications@redteamobile.com</a>-->
    <!--          {{$t('RedteaGo.sDes1')}}-->
    <!--          <a-->
    <!--            href="https://sim.redteago.com/?lang=en"-->
    <!--            target="blank"-->
    <!--            style="color:rgba(211, 36, 23, 1);text-decoration:underline"-->
    <!--          >https://sim.redteago.com</a>-->
    <!--          {{$t('RedteaGo.sDes2')}}-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </div>-->

    <div style="width: 11.8rem; margin: auto">
      <Divider />
    </div>

    <div style="width: 11.8rem; margin: auto; padding: 1rem 0 0.6rem 0">
      <div class="text-box">
        <p class="title" id="Android">{{ $t("RedteaGo.anTitle") }}</p>
        <div class="line"></div>
        <p class="content">{{ $t("RedteaGo.anDes") }}</p>
        <!--        <a href="https://app.redteago.com/?lang=en" target="blank">-->
        <!--          <p class="more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>-->
        <!--        </a>-->
      </div>
      <div class="img-box">
        <img src="../assets/go-web/品牌图.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RedteaGo-web",
  components: {},
  computed: {
    goImg() {
      return this.$store.state.goImg;
    },
  },
};
</script>
<style lang="less" scoped>
.go-web {
  .flex-box {
    display: flex;
    justify-content: space-between;
    width: 11.8rem;
    margin: auto;
  }
  .content {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Light";
    font-size: 14px;
    text-align: left;
  }
  .title {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Regular";
    font-size: 20px;
    text-align: left;
  }
  .more {
    color: rgba(207, 42, 42, 1);
    font-family: "Poppins-Light";
    font-size: 14px;
    text-align: left;
    text-decoration: underline;
    margin-top: 0.4rem;
  }
  .line {
    width: 100px;
    height: 1px;
    background: rgba(207, 42, 42, 1);
    opacity: 0.3;
    margin: 0.2rem 0;
  }
  .header {
    width: 11.8rem;
    margin: auto;
    display: flex;
    justify-content: center;
    padding: 0.8rem 0;
    .text-box {
      width: 5.67rem;
      text-align: left;
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      .header-title {
        font-size: 0.35rem;
        margin-top: 0.4rem;
        margin-bottom: 0.2rem;
      }
      .header-content {
        font-size: 14px;
        margin-bottom: 0.4rem;
      }
      .header-more {
        font-size: 20px;
        color: rgba(207, 42, 42, 1);
        text-decoration: underline;
      }
    }
    .img-box {
      img {
        width: 6.5rem;
      }
      margin-bottom: -0.75rem;
    }
  }
  .tech {
    width: 11.8rem;
    margin: auto;
    padding-top: 1.2rem;
    .tech-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 30px;
      margin-bottom: 0.2rem;
    }
  }
}
</style>